import React from 'react';
import { Plus, Minus } from 'lucide-react';

interface WeightAdjusterProps {
  weight: number;
  onWeightChange: (weight: number) => void;
  step?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const WeightAdjuster: React.FC<WeightAdjusterProps> = ({
  weight,
  onWeightChange,
  step = 0.5,
  min = 0,
  max = 999,
  disabled = false
}) => {
  const handleIncrease = () => {
    const newWeight = Math.min(max, weight + step);
    onWeightChange(newWeight);
  };

  const handleDecrease = () => {
    const newWeight = Math.max(min, weight - step);
    onWeightChange(newWeight);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      onWeightChange(value);
    }
  };

  const handleInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        type="button"
        onClick={handleDecrease}
        disabled={disabled || weight <= min}
        className="flex items-center justify-center w-8 h-8 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        title={`Уменьшить на ${step} кг`}
      >
        <Minus size={16} />
      </button>
      
      <input
        type="number"
        value={weight}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        step={step}
        disabled={disabled}
        className="w-20 px-2 py-1 text-center border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      />
      
      <button
        type="button"
        onClick={handleIncrease}
        disabled={disabled || weight >= max}
        className="flex items-center justify-center w-8 h-8 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        title={`Увеличить на ${step} кг`}
      >
        <Plus size={16} />
      </button>
    </div>
  );
};

export default WeightAdjuster; 